module.exports = __webpack_public_path__ + "static/media/blog-2.636817f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Home/blog-2.jpg
// module id = 153
// module chunks = 0